import {z} from "zod/v4-mini"
import {matrix4Value} from "#template/nodes/validation"
import {transformLike} from "#template/nodes/transform/fundamental"

export const objectNodeParameters = z.object({
    visible: z._default(z.boolean(), true),
    lockedTransform: z.optional(transformLike),
    $defaultTransform: z.optional(matrix4Value),
})
